import React, { useEffect, useState } from "react"
import Arrow from "../images/arrow_orange.svg"
import ArrowWhite from "../images/arrow_white.svg"
import {
  Container,
  ContainerLink,
  InfoIcon,
  ArrowContainer,
  InfoName,
  ArrowUp,
  AccordionInfo,
  HeaderContainer,
  InfoHeaderContainer,
} from "../styles/accordion.style"

export default function Accordion({
  icon,
  name,
  text,
  logo,
  link,
  background,
  showDetailDefault = false,
  target,
}) {
  const [showDetail, setShowDetail] = useState(showDetailDefault)

  useEffect(() => {
    setShowDetail(showDetailDefault)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const toggleDetail = () => setShowDetail(showDetail => !showDetail)
  return text ? (
    <Container onClick={toggleDetail}>
      <HeaderContainer color={background ? background : null} className="Row">
        <InfoHeaderContainer>
          <InfoIcon src={icon} alt={name} />
          <InfoName>{name}</InfoName>
        </InfoHeaderContainer>

        <ArrowContainer>
          <ArrowUp
            src={logo ? logo : background ? ArrowWhite : Arrow}
            open={showDetail}
          />
        </ArrowContainer>
      </HeaderContainer>
      <AccordionInfo
        open={showDetail}
        dangerouslySetInnerHTML={{ __html: text }}
      ></AccordionInfo>
    </Container>
  ) : (
    <ContainerLink
      className="Row"
      href={link ? link : null}
      target={target ? "_self" : "_blank"}
      rel="noreferrer"
    >
      <InfoHeaderContainer>
        <InfoIcon src={icon} alt={name} />
        <InfoName>{name}</InfoName>
      </InfoHeaderContainer>

      <ArrowContainer logo={true}>
        <ArrowUp src={logo ? logo : Arrow} open={showDetail} />
      </ArrowContainer>
      {showDetail ? <AccordionInfo>{text}</AccordionInfo> : null}
    </ContainerLink>
  )
}
